import { useEffect, useState } from 'react';
import { ArrowLeft, PenTool } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { Stepper } from 'components/TreatmentPlan/Review'
import { stepList, stepComponents, getStepNumber } from './helper'
import { connect } from 'react-redux';
import { TreatmentPlansActions } from 'store/actions';
import toast from 'react-hot-toast';
import { PortalSpinner } from 'components/PortalSpinner';
import { OverView } from 'components/TreatmentPlan';

let enhancer = connect(null, { ...TreatmentPlansActions });

const Review = ({ showTreatmentPlan }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [treatmentPlan, setTreatmentPlan] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)

  let { attributes } = treatmentPlan || {}
  let { base_appointment, patient_signature_required } = attributes || {}
  let { id: baseAppointmentId } = base_appointment?.data || {}
  let _stepList = stepList(patient_signature_required)

  useEffect(() => {
    loadTreatmentPlan()
  }, [id]);

  const loadTreatmentPlan = async () => {
    try {
      const { data: _treatmentPlan } = await showTreatmentPlan(id);

      setTreatmentPlan(_treatmentPlan);
      let _stepHash = getStepNumber(_treatmentPlan.attributes?.patient_signature_required)
      setCurrentStep(_stepHash[_treatmentPlan.attributes.step] || 0)

    } catch (error) {
      toast.error(error.errors || 'Failed to load treatment plan');
    }
  };

  const handleNext = () => {
    if (currentStep < _stepList.length - 1) {
      setCurrentStep((prev) => prev + 1)
    } else {
      navigate(-1)
    }
  }

  const StepContent = stepComponents[_stepList[currentStep].key]

  return (
    <div className="space-y-5">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex rounded-xl text-secondary-700 p-1.5 hover:bg-base-200 transition-colors"
      >
        <ArrowLeft size={20} />
      </button>

      <div>
        <h1 className="text-2xl font-bold text-secondary-900">Review Treatment Plan</h1>
        <p className="text-sm text-secondary-500 mt-0.5">Complete the steps below to finalize your treatment plan.</p>
      </div>

      {!treatmentPlan ? <PortalSpinner /> :
        <div>
          <Stepper
            steps={_stepList}
            currentStep={currentStep}
          />

          <div className="card bg-base-100 border border-base-200 shadow-sm rounded-2xl">
            <div className="card-body p-6">
              {(currentStep == 0 && patient_signature_required) &&
                <div className="w-full lg:max-w-[60%] mx-auto pt-5">
                  <div className="text-center space-y-2 mb-8">
                    <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 text-blue-600 mb-1">
                      <PenTool size={20} />
                    </div>
                    <h2 className="text-lg font-bold text-secondary-900">Sign Your Treatment Agreement</h2>
                    <p className="text-xs text-secondary-500 max-w-md mx-auto">
                      Please draw your signature inside the box below to authorize and proceed with your treatment plan.
                    </p>
                  </div>

                  <OverView treatmentPlan={attributes} />
                </div>
              }

              {StepContent && (
                <StepContent
                  onNext={handleNext}
                  treatmentPlanId={id}
                  baseAppointmentId={baseAppointmentId}
                />
              )}
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default enhancer(Review)
